import React, { useState } from 'react';
import { t, Trans } from '@lingui/macro';

import FlatButton from '@rover/components/src/OverflowTextModal/FlatButton';
import { Box, Flex, Link, Text } from '@rover/kibble/core';
import { PageLayout } from '@rover/react-lib/src/components/layouts';
import Elevator from '@rover/react-lib/src/components/utils/Elevator/Elevator';

import GuaranteeModal from './GuaranteeModal';
import RoverIcon from './rover-icon.svg';

const GuaranteeBanner = (): JSX.Element => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const elevatorStyles = {
    style: { borderRadius: '8px' },
  };

  const handleClick = (e?: React.MouseEvent<HTMLButtonElement>): void => {
    e?.preventDefault();
    setModalIsOpen(true);
  };

  return (
    <Box paddingBottom="12x">
      <Elevator elevation={1} {...elevatorStyles} data-testid="rover-guarantee-banner">
        <PageLayout style={{ margin: '0', padding: '0' }}>
          <Flex
            paddingBottom="0x"
            flexDirection="column"
            alignItems="flex-start"
            gap="2x"
            alignSelf="stretch"
            background="primary"
            sx={{ borderRadius: '8px' }}
          >
            <Flex padding="4x" alignItems="center" gap="4x" alignSelf="stretch">
              <RoverIcon height={64} width={64} description="Rover Logo" />

              <Flex flexDirection="column" alignItems="flex-start" flex="1 0 0">
                <Trans>
                  <Text size="200">
                    All stays booked on Rover receive{' '}
                    <Link size="200" href="https://www.rover.com/rover-guarantee/">
                      our Rover guarantee
                    </Link>
                    , 24/7 support, and our reservation protection.
                  </Text>
                </Trans>
                <FlatButton onClick={handleClick} data-testid="learn-more-button">
                  {t`Learn more`}
                </FlatButton>
              </Flex>
            </Flex>
          </Flex>
        </PageLayout>
      </Elevator>
      <GuaranteeModal isOpen={modalIsOpen} onClose={() => setModalIsOpen(false)} />
    </Box>
  );
};

export default GuaranteeBanner;
